import OfficePresentation from "./office-presentation.component";

export default OfficePresentation;
